export const COMMON_APPROVERS_WIDGET_NAMESPACE = 'widget.common-approvers'
